export const screenSizes = ["mobile", "tablet", "tablet-large", "laptop", "desktop", "desktop-wide"] as const;
export type ScreenSize = (typeof screenSizes)[number];
